<script lang="ts">
import { defineComponent } from 'vue'
import PhoneNumberForm from '@/components/phone-registration/PhoneNumberForm.vue'

export default defineComponent({
  name: 'HomeView',
  components: {
    PhoneNumberForm,
  },
})
</script>

<template>
  <div>
    <PhoneNumberForm :msg="$t('phoneNumberForm.title')" />
  </div>
</template>

<style lang="scss" scoped>
@media screen and (max-width: 500px) {
  div {
    width: 100%;
  }
}
</style>
